import axiosInstance from "../Utils/axiosConfig";

const getAllEarnCampaign = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/GetCampaigns`,
  );
  return response?.data;
};
const addEarnPlan = async (params) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/AddPlan`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params: params,
    },
  );
  return response?.data;
};

const getBonusTierInfo = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/GetBonusTierInfo`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    },
  );
  return response?.data;
};

const getEarnPlanHistory = async (params) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/GetPlanHistory`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params: params,
    },
  );
  return response?.data;
};

const getPlanDetails = async (params) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/GetPlanDetails`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params: params,
    },
  );
  return response?.data;
};

const redeemEarnPlan = async (params) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/RedeemPlan`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params: params,
    },
  );
  return response?.data;
};

const terminateEarnPlan = async (params) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_REST_URL}/earn/TerminatePlan`,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
      params: params,
    },
  );
  return response?.data;
};

export const earnService = {
  getAllEarnCampaign,
  getBonusTierInfo,
  addEarnPlan,
  getEarnPlanHistory,
  getPlanDetails,
  redeemEarnPlan,
  terminateEarnPlan,
};
